function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle",
  fill: "none",
  stroke: "#e4e9ee",
  strokeMiterlimit: 10,
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 184,
  height: 55,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 183,
  height: 54,
  rx: 4.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "Download_Linux-2",
  "data-name": "Download Linux",
  transform: "translate(49 35)",
  fill: "#fff",
  fontSize: 15,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Download Linux"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "linux-logo",
  transform: "translate(20 16)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.96,22.109a1.065,1.065,0,0,1-.366-.292,1.6,1.6,0,0,1-.206-.317.549.549,0,0,0-.274-.243,1.44,1.44,0,0,0-.585-.118q-.547-.012-1.617-.013c-.158,0-.393.006-.709.019s-.555.023-.721.031a2.879,2.879,0,0,0-.99.187,2.266,2.266,0,0,0-.665.373,2.375,2.375,0,0,1-.541.355,1.364,1.364,0,0,1-.666.143,5.626,5.626,0,0,1-1.381-.385,12.875,12.875,0,0,0-1.817-.535q-.236-.05-.635-.119c-.265-.045-.472-.083-.622-.112s-.313-.068-.491-.118a1.366,1.366,0,0,1-.417-.181.614.614,0,0,1-.212-.242,1.134,1.134,0,0,1,.087-.828,3.737,3.737,0,0,0,.224-.678,1.94,1.94,0,0,0-.05-.5c-.041-.2-.084-.375-.125-.528a1.592,1.592,0,0,1-.056-.455.448.448,0,0,1,.131-.336,1.249,1.249,0,0,1,.709-.175,1.767,1.767,0,0,0,.747-.149,1.709,1.709,0,0,0,.522-.436,1.1,1.1,0,0,0,.149-.635,1.049,1.049,0,0,1-.4,1.319,1.613,1.613,0,0,1-1.033.187q-.423-.038-.535.124-.162.186.062.709a1.963,1.963,0,0,0,.1.224q.074.15.105.224a1.053,1.053,0,0,1,.056.212,1,1,0,0,1,.013.274,1.632,1.632,0,0,1-.211.61,1.1,1.1,0,0,0-.174.6c.024.141.178.248.46.323q.248.076,1.051.23t1.238.255q.3.076.921.274c.414.132.757.228,1.026.286a2.1,2.1,0,0,0,.69.05,1.344,1.344,0,0,0,.8-.348.923.923,0,0,0,.286-.6,2.254,2.254,0,0,0-.094-.727,3.514,3.514,0,0,0-.236-.647c-.083-.162-.167-.313-.249-.455a26.374,26.374,0,0,0-2.1-3.011q-.846-.922-1.406-.5c-.091.074-.154.012-.187-.187a2.132,2.132,0,0,1-.024-.473,1.943,1.943,0,0,1,.124-.647,3.5,3.5,0,0,1,.3-.585,3.232,3.232,0,0,0,.274-.523q.1-.261.329-.9t.367-.97a6.918,6.918,0,0,1,.374-.759A3.069,3.069,0,0,1,4.8,9.73,9.583,9.583,0,0,0,6.341,7.3q-.148-1.395-.2-3.857a4.582,4.582,0,0,1,.3-1.885A2.779,2.779,0,0,1,9.054,0a4.637,4.637,0,0,1,1.319.168A3.247,3.247,0,0,1,11.48.685,3.605,3.605,0,0,1,12.619,2.2a3.91,3.91,0,0,1,.366,1.835,8.014,8.014,0,0,0,.374,2.662,6.873,6.873,0,0,0,1.654,2.713,7.022,7.022,0,0,1,1.238,2.028,10.767,10.767,0,0,1,.74,2.377,4.332,4.332,0,0,1,.062,1.051,2.156,2.156,0,0,1-.149.69c-.075.167-.158.257-.248.274a.593.593,0,0,0-.293.237c-.112.141-.224.288-.336.442a1.527,1.527,0,0,1-.5.417,1.45,1.45,0,0,1-.759.175,1.8,1.8,0,0,1-.392-.062.62.62,0,0,1-.28-.168,2.409,2.409,0,0,1-.168-.194,1.641,1.641,0,0,1-.143-.255c-.058-.121-.1-.2-.112-.243-.183-.306-.353-.431-.51-.373s-.274.261-.348.609a2.48,2.48,0,0,0,.087,1.207,5.961,5.961,0,0,1,.012,2.426,1.568,1.568,0,0,0,.225,1.25,1.022,1.022,0,0,0,.907.41,1.8,1.8,0,0,0,1.058-.442,9.067,9.067,0,0,1,1.113-.827,8.165,8.165,0,0,1,1.288-.528,3.46,3.46,0,0,0,.958-.455c.2-.153.276-.3.23-.429a.72.72,0,0,0-.31-.355,3.045,3.045,0,0,0-.641-.292,1.027,1.027,0,0,1-.616-.6,1.991,1.991,0,0,1-.186-.9.813.813,0,0,1,.193-.59,3.042,3.042,0,0,0,.1.7,2.8,2.8,0,0,0,.18.5,1.419,1.419,0,0,0,.256.355,1.827,1.827,0,0,0,.261.237q.1.069.267.162c.112.062.18.1.205.118a1.589,1.589,0,0,1,.385.305.528.528,0,0,1,.149.3.7.7,0,0,1-.031.28.653.653,0,0,1-.193.274,3.531,3.531,0,0,1-.292.243,3.4,3.4,0,0,1-.373.23c-.153.083-.284.151-.392.205s-.241.118-.4.193-.269.129-.336.162a6.57,6.57,0,0,0-1.064.7,11.988,11.988,0,0,0-.939.8,1.44,1.44,0,0,1-.846.243q-.1.007-.2.007A2.091,2.091,0,0,1,12.96,22.109Z",
  transform: "translate(0.025 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,.187c0,.05.021.071.062.062S.131.209.168.131A.221.221,0,0,1,.361,0H.236Q0,.037,0,.187Z",
  transform: "translate(7.822 5.114)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M0,.063A.205.205,0,0,1,.218.119C.28.181.328.208.361.2A.074.074,0,0,0,.4.088Q.3-.074,0,.063Z",
  transform: "translate(8.904 5.089)",
  fill: "#fff"
}));

function SvgDesktop2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_Linux",
    "data-name": "Download Linux",
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 55,
    viewBox: "0 0 184 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop2);
export default __webpack_public_path__ + "static/media/desktop2.efc5f4fc.svg";
export { ForwardRef as ReactComponent };